(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yahav-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const WISHLIST_KEY = 'yahavWishlist';
    const readWishlist = () => { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (error) { return []; } };
    const writeWishlist = (items) => { try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (error) {} };
    const syncWishlist = (scope) => {
      const saved = new Set(readWishlist());
      scope.querySelectorAll('[data-yc-wish]').forEach((button) => {
        button.setAttribute('aria-pressed', String(saved.has(button.dataset.ycWish)));
      });
    };

    const init = (root) => {
      if (!root || root.dataset.ycolReady) return;
      root.dataset.ycolReady = 'true';

      // Keep focused category links visible when the row scrolls horizontally.
      const categories = root.querySelector('.ycol-pills');
      categories?.addEventListener('focusin', (event) => {
        const pill = event.target.closest('.ycol-pill');
        if (pill && categories.scrollWidth > categories.clientWidth) {
          pill.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }
      });

      // Sort: keep active filters, reset to page 1.
      root.querySelector('[data-ycol-sort]')?.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });

      // Banner description: clamp to a few lines, reveal "Read more" only when text overflows.
      const desc = root.querySelector('[data-ycol-desc]');
      if (desc) {
        const text = desc.querySelector('.ycol-banner__text');
        const more = desc.querySelector('[data-ycol-more]');
        const labelMore = more.textContent;
        const labelLess = root.dataset.ycolLessLabel || 'Read less';
        const check = () => {
          if (desc.classList.contains('is-open')) return;
          more.hidden = text.scrollHeight <= text.clientHeight + 1;
        };
        more.addEventListener('click', () => {
          const open = desc.classList.toggle('is-open');
          more.setAttribute('aria-expanded', String(open));
          more.textContent = open ? labelLess : labelMore;
        });
        check();
        window.addEventListener('resize', check);
      }

      // Filter drawer.
      const drawer = root.querySelector('[data-ycol-filters]');
      if (drawer) {
        root.querySelector('[data-ycol-open-filters]')?.addEventListener('click', () => { drawer.showModal(); document.documentElement.classList.add('ycol-lock'); });
        drawer.querySelector('[data-ycol-close-filters]')?.addEventListener('click', () => drawer.close());
        drawer.addEventListener('close', () => document.documentElement.classList.remove('ycol-lock'));
        drawer.addEventListener('click', (event) => { if (event.target === drawer) drawer.close(); });
        drawer.querySelector('form')?.addEventListener('submit', (event) => {
          // Drop empty price fields so they do not become blank filter params.
          event.target.querySelectorAll('input[type="number"]').forEach((input) => { if (input.value === '') input.disabled = true; });
        });
      }

      // Delegation also handles hearts on products added by endless scrolling.
      syncWishlist(root);
      root.addEventListener('ycol:products:added', (event) => {
        event.detail.cards.forEach(syncWishlist);
      });
      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-yc-wish]');
        if (!button || !root.contains(button)) return;
        const items = new Set(readWishlist());
        const handle = button.dataset.ycWish;
        if (items.has(handle)) items.delete(handle); else items.add(handle);
        writeWishlist([...items]);
        button.setAttribute('aria-pressed', String(items.has(handle)));
      });
    };

    document.querySelectorAll('.ycol').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('.ycol')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yahav-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yahav-hero-video')) {
    customElements.define('yahav-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.video = this.querySelector('video');
        this.button = this.closest('.yahav-hero')?.querySelector('.yahav-hero__video-toggle');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        // Visitors who turn off motion see the image; they can still start the video with the button.
        this.userPaused = this.reducedMotion.matches;
        this.visible = true;

        this.button?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.sync(); }, { signal });
        this.mobile.addEventListener?.('change', () => this.load(), { signal });
        this.reducedMotion.addEventListener?.('change', () => { this.userPaused = this.reducedMotion.matches; this.sync(); }, { signal });
        this.video.addEventListener('playing', () => this.classList.add('is-playing'), { signal });
        this.video.addEventListener('error', () => this.classList.remove('is-playing'), { signal });

        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.visible = entries[entries.length - 1].isIntersecting;
          this.sync();
        });
        this.intersectionObserver.observe(this);
        this.load();
      }

      load() {
        const src = (this.mobile.matches && this.dataset.mobileSrc) || this.dataset.src || this.dataset.mobileSrc;
        if (src && this.video.getAttribute('src') !== src) {
          this.classList.remove('is-playing');
          this.video.src = src;
        }
        this.sync();
      }

      sync() {
        if (!this.userPaused && this.visible) {
          this.video.preload = 'auto';
          this.video.play()?.catch(() => {});
        } else {
          this.video.pause();
        }
        if (!this.button) return;
        const label = this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        this.button.setAttribute('aria-pressed', String(this.userPaused));
        this.button.setAttribute('aria-label', label);
        this.button.title = label;
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.intersectionObserver?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yahav-pills"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yahav-pills')) {
    customElements.define('yahav-pills', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.viewport = this.querySelector('.yahav-pills__viewport');
        this.track = this.querySelector('.yahav-pills__track');
        this.set = this.querySelector('.yahav-pills__set');
        this.button = this.querySelector('.yahav-pills__pause');
        if (this.dataset.animate !== 'true' || !this.set || !this.set.children.length) return;

        this.userPaused = false;
        this.editorPaused = false;
        this.visible = true;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.button?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.sync(); }, { signal });
        this.reducedMotion.addEventListener?.('change', () => this.schedule(), { signal });
        this.addEventListener('shopify:block:select', () => { this.editorPaused = true; this.sync(); }, { signal });
        this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.sync(); }, { signal });

        this.resizeObserver = new ResizeObserver(() => this.schedule());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.set);
        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.visible = entries[entries.length - 1].isIntersecting;
          this.sync();
        }, { rootMargin: '100px 0px' });
        this.intersectionObserver.observe(this);
        document.fonts?.ready.then(() => { if (!signal.aborted) this.schedule(); });

        this.layout();
      }

      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.layout());
      }

      layout() {
        if (this.reducedMotion.matches) {
          this.setClones(0);
          this.dataset.marquee = 'off';
          return;
        }
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const setWidth = this.set.getBoundingClientRect().width;
        if (!setWidth) return;
        const shift = setWidth + gap;
        // Enough copies that the strip is always wider than the screen plus one loop, so no gap ever shows.
        this.setClones(Math.ceil(this.viewport.clientWidth / shift));
        this.style.setProperty('--yh-shift', `${shift}px`);
        this.dataset.marquee = 'on';
        this.sync();
      }

      setClones(count) {
        const clones = this.track.querySelectorAll('.yahav-pills__set--clone');
        if (clones.length === count) return;
        clones.forEach((clone) => clone.remove());
        for (let i = 0; i < count; i++) {
          const clone = this.set.cloneNode(true);
          clone.classList.add('yahav-pills__set--clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          this.track.append(clone);
        }
      }

      sync() {
        this.dataset.paused = String(this.userPaused || this.editorPaused || !this.visible);
        if (!this.button) return;
        const label = this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        this.button.setAttribute('aria-pressed', String(this.userPaused));
        this.button.setAttribute('aria-label', label);
        this.button.title = label;
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yahav-product-features"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Foam drifts at two speeds while the section scrolls past, like soapy water behind the content.
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const init = (root) => {
      if (!root || root.dataset.ypfReady || !root.querySelector('.ypf__foam')) return;
      root.dataset.ypfReady = 'true';
      let visible = false;
      let frame;
      const update = () => {
        frame = null;
        if (!visible || reduce.matches) return;
        const rect = root.getBoundingClientRect();
        const progress = Math.min(Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0), 1);
        root.style.setProperty('--ypf-progress', progress.toFixed(3));
      };
      const request = () => { if (!frame) frame = requestAnimationFrame(update); };
      new IntersectionObserver((entries) => {
        visible = entries[entries.length - 1].isIntersecting;
        root.classList.toggle('is-in-view', visible);
        if (visible) request();
      }, { rootMargin: '100px 0px' }).observe(root);
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
    };
    document.querySelectorAll('[data-ypf]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-ypf]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yahav-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (cents, format) => {
      const fmt = format || '$' + '{' + '{amount}' + '}';
      const value = (cents / 100).toFixed(2);
      const [whole, decimals] = value.split('.');
      const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        if (key === 'amount_no_decimals') return withCommas;
        if (key === 'amount_with_comma_separator') return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${decimals}`;
        if (key === 'amount_no_decimals_with_comma_separator') return whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${withCommas}.${decimals}`;
      }).replace(/<[^>]*>/g, '');
    };

    const init = (root) => {
      if (!root || root.dataset.ypReady) return;
      root.dataset.ypReady = 'true';
      const product = JSON.parse(root.querySelector('[data-yp-product]').textContent);
      const viewer = root.querySelector('[data-yp-viewer]');
      const slides = [...root.querySelectorAll('[data-yp-slide]')];
      const thumbs = [...root.querySelectorAll('[data-yp-go]')];
      const dots = [...root.querySelectorAll('[data-yp-dot]')];
      const form = root.querySelector('[data-yp-form]');
      const idInput = root.querySelector('[data-yp-variant-id]');
      const selects = [...root.querySelectorAll('[data-yp-option]')];
      const atc = root.querySelector('[data-yp-atc]');
      const atcLabel = root.querySelector('[data-yp-atc-label]');
      const labels = { add: root.dataset.labelAdd, soldOut: root.dataset.labelSoldOut, unavailable: root.dataset.labelUnavailable };
      const moneyFormat = root.dataset.moneyFormat;

      // Gallery
      let target = 0;
      const goTo = (index, smooth = true) => {
        const slide = slides[index];
        if (!slide) return;
        target = index;
        setActive(index);
        viewer.scrollTo({ left: slide.offsetLeft - viewer.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      };
      const setActive = (index) => {
        thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === index); t.toggleAttribute('aria-current', i === index); });
        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        const strip = root.querySelector('[data-yp-thumbs]');
        const thumb = thumbs[index];
        if (strip && thumb) {
          const left = thumb.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft) strip.scrollTo({ left, behavior: 'smooth' });
          else if (left + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: left + thumb.offsetWidth - strip.clientWidth, behavior: 'smooth' });
        }
      };
      const current = () => target;
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.ypGo))));
      root.querySelectorAll('[data-yp-step]').forEach((button) => button.addEventListener('click', () => {
        const next = (current() + Number(button.dataset.ypStep) + slides.length) % slides.length;
        goTo(next);
      }));
      if (viewer && slides.length > 1) {
        // Sync thumbnails once scrolling settles, so long arrow jumps and swipes both end on the right image.
        let settle;
        viewer.addEventListener('scroll', () => {
          clearTimeout(settle);
          settle = setTimeout(() => {
            delete viewer.dataset.animating;
            const index = Math.round(viewer.scrollLeft / viewer.clientWidth);
            target = index;
            setActive(index);
          }, 120);
        }, { passive: true });
        viewer.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') { event.preventDefault(); goTo(Math.min(current() + 1, slides.length - 1)); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(Math.max(current() - 1, 0)); }
        });
      }

      // Variants
      const findVariant = () => {
        const values = selects.map((s) => s.value);
        return product.variants.find((v) => v.options.every((o, i) => o === values[i]));
      };
      const update = (announce = true) => {
        const variant = selects.length ? findVariant() : product.variants[0];
        if (!variant) {
          atc.disabled = true;
          atcLabel.textContent = labels.unavailable;
          document.dispatchEvent(new CustomEvent('yahav:variant-change', { detail: { productId: product.id, variant: null } }));
          return;
        }
        idInput.value = variant.id;
        root.querySelector('[data-yp-price]').textContent = money(variant.price, moneyFormat);
        const compare = root.querySelector('[data-yp-compare]');
        compare.hidden = !(variant.compare_at_price > variant.price);
        if (!compare.hidden) compare.textContent = money(variant.compare_at_price, moneyFormat);
        atc.disabled = !variant.available;
        atcLabel.textContent = variant.available ? labels.add : labels.soldOut;
        if (variant.featured_media) {
          const index = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
          if (index > -1) goTo(index);
        }
        if (announce) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        document.dispatchEvent(new CustomEvent('yahav:variant-change', { detail: { productId: product.id, variant } }));
      };
      selects.forEach((select) => select.addEventListener('change', () => update()));

      // Button-style options drive their hidden select, so variant matching stays in one place.
      root.querySelectorAll('[data-yp-pills]').forEach((group) => {
        const select = selects[Number(group.dataset.ypPills)];
        const value = group.closest('.yp__option')?.querySelector('[data-yp-option-value]');
        if (!select) return;
        group.addEventListener('change', (event) => {
          if (!event.target.matches('input[type="radio"]')) return;
          select.value = event.target.value;
          select.dispatchEvent(new Event('change'));
        });
        select.addEventListener('change', () => {
          group.querySelectorAll('input[type="radio"]').forEach((radio) => { radio.checked = radio.value === select.value; });
          if (value) value.textContent = select.value;
        });
      });

      // Choice cards show their price for the other options currently selected (e.g. the chosen size).
      const choicePrices = () => root.querySelectorAll('[data-yp-pills]').forEach((group) => {
        const index = Number(group.dataset.ypPills);
        group.querySelectorAll('.yp__choice').forEach((choice) => {
          const radio = choice.querySelector('input');
          const price = choice.querySelector('[data-yp-choice-price]');
          const values = selects.map((s) => s.value);
          values[index] = radio.value;
          const variant = product.variants.find((v) => v.options.every((o, i) => o === values[i]));
          if (price) price.textContent = variant ? money(variant.price, moneyFormat) : '';
          choice.classList.toggle('is-unavailable', !variant || !variant.available);
        });
      });
      selects.forEach((select) => select.addEventListener('change', choicePrices));

      // Option explainer popup (e.g. Standard vs Professional). Closes from its button, Escape or a backdrop click.
      // "Choose …" picks that value for the option and closes the popup.
      const help = root.querySelector('[data-yp-help]');
      if (help && typeof help.showModal === 'function') {
        const helpSelect = selects.find((s) => s.dataset.optionName.trim().toLowerCase() === help.dataset.option);
        const markCurrent = () => help.querySelectorAll('[data-yp-help-item]').forEach((item) => {
          item.classList.toggle('is-current', !!helpSelect && item.dataset.ypHelpItem === helpSelect.value.trim().toLowerCase());
        });
        root.querySelectorAll('[data-yp-help-open]').forEach((button) => button.addEventListener('click', () => { markCurrent(); help.showModal(); }));
        help.addEventListener('click', (event) => { if (event.target === help) help.close(); });
        help.querySelectorAll('[data-yp-help-choose]').forEach((button) => button.addEventListener('click', () => {
          const option = helpSelect && [...helpSelect.options].find((o) => o.value.trim().toLowerCase() === button.dataset.ypHelpChoose.toLowerCase());
          if (option) {
            helpSelect.value = option.value;
            helpSelect.dispatchEvent(new Event('change'));
          }
          help.close();
        }));
      } else {
        root.querySelectorAll('[data-yp-help-open]').forEach((button) => { button.hidden = true; });
      }

      // Other sections (size guide) can pick an option value.
      document.addEventListener('yahav:select-option', (event) => {
        const { optionName, value } = event.detail || {};
        const select = selects.find((s) => s.dataset.optionName === optionName);
        if (!select || ![...select.options].some((o) => o.value === value)) return;
        select.value = value;
        select.dispatchEvent(new Event('change'));
      });

      // Quantity
      const qty = root.querySelector('[data-yp-qty-input]');
      root.querySelectorAll('[data-yp-qty]').forEach((button) => button.addEventListener('click', () => {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(button.dataset.ypQty));
      }));

      // Design request (custom products): idea + optional file go to the cart as line item properties.
      // Fields only get their property name when filled, so empty ones are not added to the order.
      // The file input sits outside the form (joined by its form attribute) so the cart drawer still accepts it.
      const design = root.querySelector('[data-yp-design]');
      if (design) {
        const idea = design.querySelector('[data-yp-design-idea]');
        const file = root.querySelector('[data-yp-design-file]');
        const drop = design.querySelector('[data-yp-design-drop]');
        const chosen = design.querySelector('[data-yp-design-chosen]');
        const error = design.querySelector('[data-yp-design-error]');
        const count = design.querySelector('[data-yp-design-count]');
        const maxBytes = Number(file.dataset.maxMb) * 1024 * 1024;
        const showError = (message) => { error.textContent = message; error.hidden = !message; };
        const thumb = design.querySelector('[data-yp-design-thumb]');
        const doc = design.querySelector('[data-yp-design-doc]');
        const links = design.querySelectorAll('[data-yp-design-preview], [data-yp-design-view]');
        let previewUrl = '';
        const formatSize = (bytes) => (bytes >= 1048576 ? `${(bytes / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`);
        // Shows what was picked: a thumbnail for images, a file badge otherwise, and a link to open it in full.
        const showFile = () => {
          const picked = file.files[0];
          if (previewUrl) URL.revokeObjectURL(previewUrl);
          previewUrl = picked ? URL.createObjectURL(picked) : '';
          chosen.hidden = !picked;
          drop.hidden = !!picked;
          design.querySelector('[data-yp-design-name]').textContent = picked ? picked.name : '';
          design.querySelector('[data-yp-design-size]').textContent = picked ? formatSize(picked.size) : '';
          const isImage = !!picked && picked.type.startsWith('image/');
          thumb.hidden = !isImage;
          doc.hidden = !picked || isImage;
          if (isImage) thumb.src = previewUrl; else thumb.removeAttribute('src');
          design.querySelector('[data-yp-design-ext]').textContent = picked ? (picked.name.split('.').pop() || '').slice(0, 4).toUpperCase() : '';
          links.forEach((link) => { link.href = previewUrl || '#'; });
        };
        idea.addEventListener('input', () => { count.textContent = idea.value.length; });
        file.addEventListener('change', () => {
          const picked = file.files[0];
          if (picked && maxBytes > 0 && picked.size > maxBytes) {
            file.value = '';
            showError(error.dataset.sizeMessage);
          } else {
            showError('');
          }
          showFile();
        });
        design.querySelector('[data-yp-design-remove]').addEventListener('click', () => { file.value = ''; showError(''); showFile(); file.dispatchEvent(new Event('change')); drop.focus?.(); });
        ['dragenter', 'dragover'].forEach((type) => drop.addEventListener(type, (event) => { event.preventDefault(); drop.classList.add('is-over'); }));
        ['dragleave', 'drop'].forEach((type) => drop.addEventListener(type, () => drop.classList.remove('is-over')));
        drop.addEventListener('drop', (event) => {
          event.preventDefault();
          if (!event.dataTransfer?.files?.length) return;
          file.files = event.dataTransfer.files;
          file.dispatchEvent(new Event('change'));
        });
        file.addEventListener('focus', () => drop.classList.add('is-focused'));
        file.addEventListener('blur', () => drop.classList.remove('is-focused'));
        const nameDesignFields = () => {
          [idea, file].forEach((field) => {
            const filled = field === file ? file.files.length > 0 : field.value.trim() !== '';
            if (filled) field.name = field.dataset.property;
            else field.removeAttribute('name');
          });
        };
        // "Idea or file" rule: Add to Cart looks disabled (aria-disabled) until one is given. It stays clickable
        // so a click can point the customer back to the form; the real disabled state stays for sold-out variants.
        const hint = root.querySelector('[data-yp-design-hint]');
        const needsInput = () => !!hint && idea.value.trim() === '' && file.files.length === 0;
        const updateGate = () => {
          if (!hint || !atc) return;
          const blocked = needsInput();
          atc.classList.toggle('is-blocked', blocked);
          if (blocked) {
            atc.setAttribute('aria-disabled', 'true');
            atc.setAttribute('aria-describedby', hint.id);
          } else {
            atc.removeAttribute('aria-disabled');
            atc.removeAttribute('aria-describedby');
          }
          hint.hidden = !blocked || atc.disabled;
          design.classList.toggle('is-required', blocked && design.classList.contains('is-required'));
        };
        const pointToDesign = () => {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          design.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          idea.focus({ preventScroll: true });
          design.classList.add('is-required');
          design.classList.remove('is-highlighted');
          void design.offsetWidth;
          design.classList.add('is-highlighted');
        };
        const ideaMissing = () => {
          if (needsInput()) { pointToDesign(); return true; }
          if (!idea.required || idea.value.trim()) return false;
          idea.focus();
          idea.reportValidity();
          return true;
        };
        idea.addEventListener('input', updateGate);
        file.addEventListener('change', updateGate);
        // Variant changes toggle atc.disabled (sold out); keep the hint in step with it.
        if (atc) new MutationObserver(updateGate).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
        updateGate();
        // Runs before the cart drawer reads the form (capture phase), and on a normal submit.
        atc?.addEventListener('click', (event) => {
          if (atc.disabled) return;
          if (ideaMissing()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
          nameDesignFields();
        }, true);
        form.addEventListener('submit', (event) => {
          if (ideaMissing()) { event.preventDefault(); return; }
          nameDesignFields();
        });
      }

      // Add to cart: hand over to the theme's cart drawer when it exists, otherwise submit normally.
      atc?.addEventListener('click', (event) => {
        if (atc.disabled) return;
        const drawer = window.theme?.settings?.cartType === 'drawer' && document.querySelector('cart-drawer');
        if (!drawer) return;
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: atc }, bubbles: false }));
      });

      // Free shipping progress: cart total now, plus a preview of what this item adds.
      const fs = root.querySelector('[data-yp-fs]');
      if (fs) {
        const rate = Number(window.Shopify?.currency?.rate) || 1;
        const limit = Math.round(Number(fs.dataset.limit) * rate);
        let cartTotal = Number(fs.dataset.cartTotal) || 0;
        const text = fs.querySelector('[data-yp-fs-text]');
        const track = fs.querySelector('[data-yp-fs-track]');
        const fill = fs.querySelector('[data-yp-fs-cart]');
        const preview = fs.querySelector('[data-yp-fs-item]');
        const escapeHtml = (value) => value.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        const format = (value, amount = '') => escapeHtml(value || '')
          .replace('[amount]', '@@AMOUNT@@')
          .replace(/\[/g, '<strong>')
          .replace(/\]/g, '</strong>')
          .replace('@@AMOUNT@@', `<strong>${amount}</strong>`);
        const renderFs = () => {
          const variant = selects.length ? findVariant() : product.variants.find((item) => String(item.id) === idInput.value);
          const quantity = Number(qty?.value || 1);
          const eligible = variant?.available && variant.requires_shipping !== false && Number.isInteger(quantity) && quantity > 0 && (!qty || qty.checkValidity());
          fs.hidden = !(limit > 0 && eligible);
          if (fs.hidden) return;
          const after = cartTotal + variant.price * quantity;
          const cartPercent = Math.min(100, (cartTotal / limit) * 100);
          const afterPercent = Math.min(100, (after / limit) * 100);
          let message;
          if (cartTotal >= limit) message = format(fs.dataset.textDone);
          else if (after >= limit) message = format(fs.dataset.textUnlock);
          else message = format(fs.dataset.textRemaining, money(limit - after, moneyFormat));
          text.innerHTML = message;
          fill.style.width = `${cartPercent}%`;
          preview.style.left = `${cartPercent}%`;
          preview.style.width = `${afterPercent - cartPercent}%`;
          track.setAttribute('aria-valuenow', Math.round(cartPercent));
          fs.classList.toggle('is-unlocked', cartTotal >= limit);
          fs.classList.toggle('is-unlockable', cartTotal < limit && after >= limit);
        };
        let cartRequest;
        let requestId = 0;
        const refreshCart = async () => {
          const id = ++requestId;
          cartRequest?.abort();
          cartRequest = new AbortController();
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store', signal: cartRequest.signal });
            if (!response.ok) throw new Error('Cart refresh failed');
            const cart = await response.json();
            if (id !== requestId || !Number.isFinite(cart.total_price)) return;
            cartTotal = Math.max(0, cart.total_price);
            renderFs();
          } catch (error) {
            if (error.name !== 'AbortError' && id === requestId) fs.hidden = true;
          }
        };
        selects.forEach((select) => select.addEventListener('change', renderFs));
        qty?.addEventListener('input', renderFs);
        root.querySelectorAll('[data-yp-qty]').forEach((button) => button.addEventListener('click', renderFs));
        ['theme:cart:change', 'theme:cart:refresh', 'theme:cart:update', 'cart:updated', 'cart:refresh'].forEach((name) => document.addEventListener(name, refreshCart));
        window.addEventListener('pageshow', refreshCart);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCart(); });
        document.addEventListener('yahav:variant-change', renderFs);
        refreshCart();
        renderFs();
      }

      update(false);
    };

    document.querySelectorAll('[data-yp]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-yp]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yahav-related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const load = async (root) => {
      if (!root || root.dataset.yrpReady || root.querySelector('.yahav-cards__grid')) return;
      root.dataset.yrpReady = 'true';
      try {
        const response = await fetch(root.dataset.url);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = html.querySelector('[data-yrp]');
        if (fresh && fresh.innerHTML.trim()) root.innerHTML = fresh.innerHTML;
        else root.hidden = true;
      } catch (error) {
        root.hidden = true;
      }
    };
    const observe = (root) => {
      if (!root) return;
      if (!('IntersectionObserver' in window)) return load(root);
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { observer.disconnect(); load(root); }
      }, { rootMargin: '600px 0px' });
      observer.observe(root);
    };
    document.querySelectorAll('[data-yrp]').forEach(observe);
    document.addEventListener('shopify:section:load', (event) => observe(event.target.querySelector('[data-yrp]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
